







































































































































import { computed, defineNuxtComponent } from '~/utils/nuxt3-migration'
import CHybridTelephone from '~/components/shared/configurable/telephone/CHybridTelephone.vue'
import CGoogleMapEmbed from '~/components/shared/configurable/map/CGoogleMapEmbed.vue'
import CStarBar from '~/components/shared/configurable/rating/CStarBar.vue'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import OutletSocialIconGroup from '~/components/car/dealers/site/outlet/OutletSocialIconGroup.vue'
import DirectionsButton from '~/components/car/maps/DirectionsButton.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  DEALER_SITE_NS,
  DealerSiteState
} from '~/store/modules/shared/dealers/site/state'
import { ciExternalLink } from '~/icons/source/regular/external-link'

export default defineNuxtComponent({
  components: {
    CBadge,
    CGoogleMapEmbed,
    CHybridTelephone,
    DirectionsButton,
    OutletSocialIconGroup,
    CStarBar
  },
  setup() {
    const { getters } = useNamespacedStore<DealerSiteState>(DEALER_SITE_NS)

    const outlet = computed(() => getters('activeOutlet'))

    return {
      ciExternalLink,
      outlet
    }
  }
})
